(function() {
    
    const queryString = window.location.search;
    const urlParameters = new URLSearchParams(queryString);
    const clientApiKey = '483qs83ndytj53jimSEGbtyn949t2';
    
    // Check for URL parameters (support both 'order' and 'orderNumber')
    const billingEmail = urlParameters.get('email');
    const orderID = urlParameters.get('order') || urlParameters.get('orderNumber');

    if( orderID && billingEmail ) {
        // Clean and validate URL parameters
        const cleanOrder = orderID.toString().trim().replace(/[^a-zA-Z0-9]/g, '');
        const cleanEmail = billingEmail.toString().trim().toLowerCase();
        
        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        
        if (cleanOrder && emailRegex.test(cleanEmail)) {
            // Pre-fill form fields with URL parameters
            document.getElementById('order_id').value = cleanOrder;
            document.getElementById('billingEmail').value = cleanEmail;
            
            // Hide form and fetch order details automatically
            document.getElementById('form_container').style.display = 'none';
            document.getElementById('trackorder_button').classList.add('disabled');
            fetchOrderDetails( clientApiKey, cleanEmail, cleanOrder );
        } else {
            // Invalid parameters, show error
            showError('Invalid order number or email in URL. Please enter your details below.');
        }
    }

    // Event listeners
    document.addEventListener('DOMContentLoaded', function() {
        // Track order button click
        const trackButton = document.getElementById('trackorder_button');
        if (trackButton) {
            trackButton.addEventListener('click', function(e) {
                e.preventDefault();
                trackButton.classList.add('disabled');

                const orderID = document.getElementById('order_id').value;
                const billingEmail = document.getElementById('billingEmail').value;

                if( !orderID || !billingEmail ) {
                    alert('Please complete the needed fields');
                    trackButton.classList.remove('disabled');
                } else {
                    fetchOrderDetails( clientApiKey, billingEmail, orderID );
                }
            });
        }

        // Track another order buttons click (both alert and order details)
        const trackAnotherButtons = document.querySelectorAll('.track-another-order-btn');
        trackAnotherButtons.forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                showForm();
            });
        });
    });

    function fetchOrderDetails ( clientApiKey, email, orderNumber) {
        fetch(`https://app-lj-shipping-charges.azurewebsites.net/ShopifyOrderStatus/order-details/?clientApiKey=${clientApiKey}&orderNumber=${encodeURIComponent(orderNumber)}&customerEmail=${encodeURIComponent(email)}`)
            .then(res => res.json())
            .then(data => {
                document.getElementById('trackorder_button').classList.remove('disabled');
                if (data.hasErrors === false && data.order) {
                    // Update URL with current search parameters
                    const newUrl = `${window.location.pathname}?order=${encodeURIComponent(orderNumber)}&email=${encodeURIComponent(email)}`;
                    history.pushState({order: orderNumber, email: email}, '', newUrl);
                    
                    displayOrderDetails(data);
                } else {
                    showError(data.errorMessage || 'Order not found. Please check your order number and email address.');
                }
            })
            .catch(err => {
                document.getElementById('trackorder_button').classList.remove('disabled');
                console.error('API Error:', err);
                showError('Unable to retrieve order details. Please try again later.');
            });
    }

    function displayOrderDetails(orderData) {
        // Hide form and show order details
        document.getElementById('form_container').style.display = 'none';
        const alertContainer = document.getElementById('alert_container');
        if (alertContainer) alertContainer.style.display = 'none';
        
        // Populate order details
        populateOrderDetails(orderData.order);
        
        // Show order details container
        document.getElementById('order_details_container').style.display = 'block';
    }

    function populateOrderDetails(order) {
        try {
            // Update header information
            const customerFirstName = order.contactInformation.customer.firstName;

            const thankYouName = document.getElementById('order_thank_you_name');
            if (thankYouName) thankYouName.textContent = customerFirstName;
            
            const orderNumber = document.getElementById('order_number_display');
            if (orderNumber) orderNumber.textContent = `Order ${order.number}`;
        
            // Update delivery information
            const deliveryMessage = generateDeliveryMessage(order);
            const deliveryElement = document.getElementById('delivery_estimate');
            const deliverySection = document.getElementById('delivery_section');
            
            if (deliveryMessage && deliveryElement && deliverySection) {
                deliveryElement.innerHTML = deliveryMessage;
                deliverySection.style.display = 'block';
            } else if (deliverySection) {
                deliverySection.style.display = 'none';
            }
        
            // Populate order items
            if (order.lineItems && order.lineItems.length > 0) {
                let itemsHtml = '';
                let subtotal = 0;
                
                order.lineItems.forEach(item => {
                    const itemTotal = parseFloat(item.price) * item.quantity;
                    subtotal += itemTotal;
                    const imageUrl = item.product.images && item.product.images.length > 0 ? item.product.images[0].src : '';
                    
                    itemsHtml += `
                        <tr class="order-item">
                            <td class="item-details">
                                <div class="item-quantity-badge">${item.quantity}</div>
                                ${imageUrl ? `<img src="${imageUrl}" alt="${item.name}" class="item-image">` : '<div class="item-image-placeholder"></div>'}
                                <div class="item-info">
                                    <div class="item-name">${item.name}</div>
                                    ${item.variantTitle ? `<div class="item-variant">${item.variantTitle}</div>` : ''}
                                </div>
                            </td>
                            <td class="item-price">${formatMoney(itemTotal.toFixed(2))}</td>
                        </tr>
                    `;
                });
                
                const orderItemsTbody = document.getElementById('order_items_tbody');
                if (orderItemsTbody) orderItemsTbody.innerHTML = itemsHtml;
            }
        
            // Populate customer information
            const contactEmail = document.getElementById('contact_email');
            if (contactEmail) contactEmail.textContent = order.contactInformation.email;
            
            const contactPhone = document.getElementById('contact_phone');
            if (contactPhone) contactPhone.textContent = order.contactInformation.customer.phone || 'N/A';
        
            // Payment method - hide section if no transactions (free orders)
            let currency = 'GBP';
            let totalAmount = 0;
            
            const paymentMethodElement = document.getElementById('payment_method');
            
            if (order.transactions && order.transactions.length > 0) {
                const transaction = order.transactions[0];
                const paymentDetails = transaction.paymentDetails || {};
                let paymentMethod = 'Pending';
                
                // Set currency and total from transaction
                currency = transaction.currency || 'GBP';
                totalAmount = parseFloat(transaction.amount) || 0;
                
                // Check payment method priority: Card Details > Wallet > PayPal > Klarna > Gateway
                if (paymentDetails.credit_card_company && paymentDetails.credit_card_number) {
                    // Regular card payment - HIGHEST PRIORITY (shows actual card used)
                    paymentMethod = `${paymentDetails.credit_card_company} ending with ${paymentDetails.credit_card_number.slice(-4)}`;
                } else if (paymentDetails.credit_card_wallet && paymentDetails.credit_card_wallet !== 'shopify_pay') {
                    // True wallet payments (Apple Pay, Google Pay, etc.) - but not generic Shopify Pay
                    const walletType = paymentDetails.credit_card_wallet.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
                    paymentMethod = walletType;
                } else if (transaction.gateway === 'paypal') {
                    paymentMethod = 'PayPal';
                } else if (transaction.gateway && transaction.gateway.toLowerCase() === 'klarna') {
                    paymentMethod = 'Klarna';
                } else if (paymentDetails.credit_card_wallet) {
                    // Fallback for generic shopify_pay
                    const walletType = paymentDetails.credit_card_wallet.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase());
                    paymentMethod = walletType;
                } else if (transaction.gateway) {
                    // Fallback to gateway name
                    paymentMethod = transaction.gateway.charAt(0).toUpperCase() + transaction.gateway.slice(1);
                }
                
                // Show payment method section
                if (paymentMethodElement) {
                    paymentMethodElement.textContent = paymentMethod;
                    paymentMethodElement.style.display = 'block';
                    // Show the h3 title before it
                    const paymentTitle = paymentMethodElement.previousElementSibling;
                    if (paymentTitle && paymentTitle.tagName === 'H3') {
                        paymentTitle.style.display = 'block';
                    }
                }
            } else {
                // Hide payment method section for free orders
                if (paymentMethodElement) {
                    paymentMethodElement.style.display = 'none';
                    // Hide the h3 title before it
                    const paymentTitle = paymentMethodElement.previousElementSibling;
                    if (paymentTitle && paymentTitle.tagName === 'H3') {
                        paymentTitle.style.display = 'none';
                    }
                }
            }
        
            // Display totals - use API totals if available, otherwise calculate from line items
            let subtotal = 0;
            let totalDiscount = 0;
            
            if (order.totals) {
                // Use backend-provided totals (preferred)
                subtotal = parseFloat(order.totals.subtotal) || 0;
                const apiShipping = order.totals.shipping || '0.00';
                const apiDiscounts = order.totals.discounts || '0.00';
                const apiTotal = order.totals.total || totalAmount.toFixed(2);
                
                const orderSubtotal = document.getElementById('order_subtotal');
                if (orderSubtotal) orderSubtotal.textContent = formatMoney(subtotal.toFixed(2));
                
                // Handle shipping display - show FREE for zero or negative shipping (discounts)
                const shippingValue = parseFloat(apiShipping);
                const orderShipping = document.getElementById('order_shipping');
                if (orderShipping) {
                    if (shippingValue <= 0) {
                        orderShipping.textContent = 'FREE';
                    } else {
                        orderShipping.textContent = formatMoney(apiShipping);
                    }
                }
                
                const orderTotal = document.getElementById('order_total');
                if (orderTotal) orderTotal.textContent = formatMoney(apiTotal);
                
                // Show/hide discounts row based on whether discounts exist
                const discountsRow = document.querySelector('.discounts-row');
                const orderDiscounts = document.getElementById('order_discounts');
                
                if (parseFloat(apiDiscounts) > 0) {
                    if (orderDiscounts) orderDiscounts.textContent = '-' + formatMoney(apiDiscounts);
                    if (discountsRow) discountsRow.style.display = 'flex';
                } else {
                    if (discountsRow) discountsRow.style.display = 'none';
                }
            } else {
                // Calculate from line items when backend totals not available
                order.lineItems.forEach(item => {
                    const itemPrice = parseFloat(item.price) || 0;
                    const itemQuantity = parseInt(item.quantity) || 0;
                    const itemDiscount = parseFloat(item.totalDiscount) || 0;
                    
                    subtotal += (itemPrice * itemQuantity);
                    totalDiscount += itemDiscount;
                });
                
                // Display calculated values
                const orderSubtotal = document.getElementById('order_subtotal');
                if (orderSubtotal) orderSubtotal.textContent = formatMoney(subtotal.toFixed(2));
                
                // For shipping, check if we have transaction amount to derive it
                let shippingCost = 0;
                if (totalAmount > 0) {
                    shippingCost = totalAmount - subtotal + totalDiscount;
                }
                
                const orderShipping = document.getElementById('order_shipping');
                if (orderShipping) {
                    orderShipping.textContent = shippingCost <= 0 ? 'FREE' : formatMoney(shippingCost.toFixed(2));
                }
                
                const orderTotal = document.getElementById('order_total');
                if (orderTotal) {
                    orderTotal.textContent = formatMoney(totalAmount > 0 ? totalAmount.toFixed(2) : subtotal.toFixed(2));
                }
                
                // Show/hide discounts row for calculated totals
                const discountsRow = document.querySelector('.discounts-row');
                const orderDiscounts = document.getElementById('order_discounts');
                
                if (totalDiscount > 0) {
                    if (orderDiscounts) orderDiscounts.textContent = '-' + formatMoney(totalDiscount.toFixed(2));
                    if (discountsRow) discountsRow.style.display = 'flex';
                } else {
                    if (discountsRow) discountsRow.style.display = 'none';
                }
            }
        
            // Set currency code from API response
            const orderCurrency = document.getElementById('order_currency');
            if (orderCurrency) orderCurrency.textContent = currency.toUpperCase();
        
            // Addresses
            const shippingAddress = document.getElementById('shipping_address');
            if (shippingAddress) shippingAddress.innerHTML = formatAddress(order.shipping.address);
            
            const billingAddress = document.getElementById('billing_address');
            if (billingAddress) billingAddress.innerHTML = formatAddress(order.shipping.address); // Same as shipping in this API
        
        } catch (error) {
            console.error('Error in populateOrderDetails:', error);
            showError('Error displaying order details. Please try again.');
        }
    }

    function generateDeliveryMessage(order) {
        const metafields = order.metafields?.custom;
        const shippingMethodName = order.shipping?.method?.name || '';
        
        const originalMatch = shippingMethodName.match(/Get it by (.+)\)/);
        const originalDateText = originalMatch ? originalMatch[1] : null;
        
        const contactCS = metafields?.track_my_order_ship_complete;
        
        // If contactCS is "false", show customer service message instead of delivery info
        if (contactCS === false || contactCS === 'false') {
            return 'Please get in touch with our <strong>customer support team</strong> concerning your order.';
        }
        
        // If contactCS !== "false", proceed with delivery information
        // Check if we have revised delivery dates in metafields
        if (metafields && metafields.revised_earliest_delivery_date && metafields.revised_latest_delivery_date) {
            const earliestDate = new Date(metafields.revised_earliest_delivery_date);
            const latestDate = new Date(metafields.revised_latest_delivery_date);
            const revisedDateText = dateRangeToString(earliestDate, latestDate);
            
            let message = '';
            if (originalDateText) {
                message += `<p>The original delivery window when the order was placed was <strong>${originalDateText}</strong></p>`;
            }
            message += `<p>The current estimated delivery window is <strong>${revisedDateText}</strong></p>`;
            
            // Add reason if available
            if (metafields.delivery_date_change_reason) {
                const reasonCode = metafields.delivery_date_change_reason;
                const reasonText = window.deliveryReasonTranslations?.[reasonCode] || 'a delivery update';
                message += `<p>Reason: <strong>${reasonText}</strong></p>`;
            }
            
            return message;
        }
        
        if (originalDateText) {
            return `<p>The estimated delivery window is still <strong>${originalDateText}</strong></p>`;
        }
        
        return null;
    }

    function formatAddress(address) {
        if (!address) return 'N/A';
        
        let formattedAddress = '';
        if (address.firstName && address.lastName) formattedAddress += `${address.firstName} ${address.lastName}<br>`;
        if (address.company) formattedAddress += `${address.company}<br>`;
        if (address.address1) formattedAddress += `${address.address1}<br>`;
        if (address.address2) formattedAddress += `${address.address2}<br>`;
        if (address.city) formattedAddress += `${address.city}`;
        if (address.province) formattedAddress += `, ${address.province}`;
        if (address.zip) formattedAddress += ` ${address.zip}<br>`;
        if (address.country) formattedAddress += `${address.country}`;
        if (address.phone) formattedAddress += `<br>${address.phone}`;
        
        return formattedAddress || 'N/A';
    }

    function showError(message) {
        const formContainer = document.getElementById('form_container');
        const orderDetailsContainer = document.getElementById('order_details_container');
        const alertContainer = document.getElementById('alert_container');
        const alertMessage = document.getElementById('alert_message');
        
        if (formContainer) formContainer.style.display = 'none';
        if (orderDetailsContainer) orderDetailsContainer.style.display = 'none';
        if (alertMessage) alertMessage.textContent = message;
        if (alertContainer) alertContainer.style.display = 'block';
    }

    function showForm() {
        const formContainer = document.getElementById('form_container');
        const orderDetailsContainer = document.getElementById('order_details_container');
        const alertContainer = document.getElementById('alert_container');
        const orderIdInput = document.getElementById('order_id');
        const emailInput = document.getElementById('billingEmail');
        const trackButton = document.getElementById('trackorder_button');
        
        // Clear URL parameters
        history.pushState({}, '', window.location.pathname);
        
        // Scroll to top smoothly
        window.scrollTo({top: 0, behavior: 'smooth'});
        
        if (orderDetailsContainer) orderDetailsContainer.style.display = 'none';
        if (alertContainer) alertContainer.style.display = 'none';
        if (formContainer) formContainer.style.display = 'block';
        
        // Clear form inputs
        if (orderIdInput) orderIdInput.value = '';
        if (emailInput) emailInput.value = '';
        if (trackButton) trackButton.classList.remove('disabled');
    }

    // Date formatting functions from additional-script.liquid
    function dateRangeToString(date1, date2) {
        if (date1.getMonth() === date2.getMonth() && date1.getYear() === date2.getYear()) {
            if (date1.getTime() === date2.getTime()) {
                return " " + date1.getDate() + " " + getMonthName(date1, date1.getMonth());
            } else {
                return " " + date1.getDate() + " — " + " " + date2.getDate() + " " + getMonthName(false, date2.getMonth());
            }
        }
        return " " + date1.getDate() + " " + getMonthName(true, date1.getMonth()) + " — " + " " + date2.getDate() + " " + getMonthName(true, date2.getMonth());
    }

    function getMonthName(short, month) {
        let months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        if (short) {
            months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        }
        return months[month];
    }

    function getOrdinalSuffix(day) {
        switch (parseInt(day)) {
            case 1: case 21: case 31: return day + "<sup>st</sup>";
            case 2: case 22: case 32: return day + "<sup>nd</sup>";
            case 3: case 23: case 33: return day + "<sup>rd</sup>";
            default: return day + "<sup>th</sup>";
        }
    }

})();